import switchFunc from 'lib/switchFunc'
import { max, min } from 'lib/arrayUtils'

export const TOUR_V2_ROOM_TYPE_CAPACITIES: Record<Tours.V2OfferRoomType, number> = {
  single: 1,
  twin: 2,
  twinShare: 1,
  triple: 3,
  tripleShare: 1,
  quad: 4,
  quadShare: 1,
  multiShare: 1,
  single_regular: 1,
  single_vip: 1,
  single_platinum: 1,
  twin_regular: 2,
  twin_vip: 2,
  twin_platinum: 2,
}

export const TOUR_V2_MIN_ROOM_TYPE_CAPACITY = min(Object.values(TOUR_V2_ROOM_TYPE_CAPACITIES))

export const TOUR_V2_MAX_ROOM_TYPE_CAPACITY = max(Object.values(TOUR_V2_ROOM_TYPE_CAPACITIES))

const roomTypeCapacitySwitchFunc = switchFunc(TOUR_V2_ROOM_TYPE_CAPACITIES, 1)

function getRoomTypeCapacity(roomType: Tours.V2OfferRoomType): number {
  return roomTypeCapacitySwitchFunc(roomType)
}

export default getRoomTypeCapacity
